import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import {useRichTextEditorContext, getAttributesForEachSelected} from 'mui-tiptap';
import TextDecrease from '@mui/icons-material/TextDecrease';
import StyledEditorMenuButtonHeadingDown
  from 'components/atoms/Editors/EditorMenuButtonHeadingDown/EditorMenuButtonHeadingDown.styles';

const EditorMenuButtonHeadingDown = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'EditorMenuButtonHeadingDown');

  const editor = useRichTextEditorContext();

  const canSetParagraph = editor?.can().setParagraph();
  const enabledHeadingLevels = useMemo(() => {
    const headingExtension = editor?.extensionManager.extensions.find((extension) => extension.name === 'heading');
    return headingExtension?.options?.levels ?? [];
  }, [editor]);

  let nextLevel, hasNextLevel;
  if (editor?.isActive('heading')) {
    const currentNodeHeadingAttributes = getAttributesForEachSelected(
      editor.state,
      'heading'
    );
    const currentNodeLevels = currentNodeHeadingAttributes.map((attrs) => attrs.level);
    const numCurrentNodeLevels = new Set(currentNodeLevels).size;
    if (numCurrentNodeLevels === 1) {
      nextLevel = currentNodeHeadingAttributes[0].level + 1;
    }

    hasNextLevel = enabledHeadingLevels.includes(nextLevel) || canSetParagraph;
  } else {
    hasNextLevel = false;
  }

  return <StyledEditorMenuButtonHeadingDown buttonRef={ref} {...innerProps}
                                            tooltipLabel="Heading down"
                                            tooltipShortcutKeys={['mod', 'Alt', 'Arrow Down']}
                                            onClick={() => editor?.chain().decreaseHeading().focus().run()}
                                            disabled={!editor?.isEditable || !hasNextLevel}
                                            IconComponent={TextDecrease}/>
});

EditorMenuButtonHeadingDown.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default EditorMenuButtonHeadingDown;
